import React from "react";
import { RMap, RMapContextProvider } from "maplibre-react-components";
import { initialLocationCenter } from "@/utils/helpers";
import { AdminPriceEdaProvider } from "./context";
import { EditorLayers } from "./EditorLayers";
import { EditorSidebar } from "./EditorSidebar";
import cls from "./styles.module.scss";

const CENTER: [number, number] = [37.6151, 55.7569];
const INITIAL_ZOOM = 11;
const PRIMARY_STYLE = "https://tiles.openfreemap.org/styles/liberty";

const AdminPriceEdaPageContent = () => {
  const center = initialLocationCenter() || CENTER;

  return (
    <div className={cls.page}>
      <EditorSidebar />

      <div className={cls.mapFrame}>
        <RMapContextProvider>
          <RMap
            id="price-eda-editor-map"
            initialCenter={center}
            initialZoom={INITIAL_ZOOM}
            style={{ width: "100%", height: "100%" }}
            mapStyle={PRIMARY_STYLE}
            onMounted={(map) => {
              map.dragRotate.disable();
              map.touchZoomRotate.disableRotation();
              map.showTileBoundaries = false;
            }}
          >
            <EditorLayers />
          </RMap>
        </RMapContextProvider>
      </div>
    </div>
  );
};

export const AdminPriceEdaPage = () => (
  <AdminPriceEdaProvider>
    <AdminPriceEdaPageContent />
  </AdminPriceEdaProvider>
);
